import React from 'react';
import PropTypes from 'prop-types';
import {
	makeStyles,
	withStyles,
	Switch,
	FormControlLabel
} from '@material-ui/core';

import AuthorizedUser from "../utils/AuthorizedUser";

const styles = makeStyles(theme => ({
	root: {
		marginLeft: 0,
		marginRight: 0,
		justifyContent: 'space-between'
	},

	reverseDirection: {
		flexDirection: "row-reverse",
	},

	spread: {
		width: "100%"
	},

	label: {
		fontSize: 16,
		paddingRight: 4
	}
}));

// forwarding ref so things like Tooltips can wrap as functional components don't allow refs
const LabeledSwitch = React.forwardRef((props, ref) => {
	let cls,
		classes = styles(),
		moreContrast = AuthorizedUser.wantsMoreContrast(),
		{className, reverse, spread, onChange, checked, color, ...rest} = props;

	reverse = reverse && classes.reverseDirection || null;
	spread = spread && classes.spread || null;
	cls = `${classes.root} ${className} ${reverse} ${spread}`;

	// in case it comes in as a string
	if (typeof checked === "string") {
		checked = checked === "true";
	}

	const CustomSwitch = withStyles(theme => ({
		root: {
			width: 36,
			height: 20,
			padding: 0,
			margin: theme.spacing(1),
		},
		switchBase: {
			padding: 2,
			'&$checked': {
			  transform: 'translateX(16px)',
			  color: theme.palette.common.white,
			  '& + $track': {
				backgroundColor: theme.palette.primary.green,
				opacity: 1,
				border: 'none',
			  },
			},
			'&$focusVisible $thumb': {
			  color: '#4AAA00',
			  border: '6px solid #fff',
			  width: 16,
			  height: 16
			},
		},
		thumb: {
			width: 16,
			height: 16,
		},
		track: {
			borderRadius: 24 / 2,
			backgroundColor: theme.palette.secondary.lightGrey,
			opacity: 1,
			transition: theme.transitions.create(['background-color', 'border']),
		},
		checked: {},
		focusVisible: {},
		/* switchBase: {
			color: moreContrast ? theme.palette.secondary.purple : null,

			'&$checked': {
				color: moreContrast ? theme.palette.secondary.purple : null,
			},

			'&$checked + $track': {
				backgroundColor: moreContrast ? theme.palette.secondary.purple : null,
			},
		}, */
	}))(Switch);

	return (
		<FormControlLabel
			{...rest}
			ref={ref}
			checked={!!checked}
			className={cls}
			classes={{label: classes.label}}
			control={
				<CustomSwitch
					color={color || "secondary"}
					inputProps={{'aria-label': rest["aria-label"] || rest.label || ''}}
					onChange={(e) => {e.target.value = e.target.checked; onChange(e);}} />
			} />
	);
});

LabeledSwitch.propTypes = {
	className: PropTypes.string,
	color: PropTypes.string,
	reverse: PropTypes.bool,
	spread: PropTypes.bool,
	checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
	onChange: PropTypes.func
};

LabeledSwitch.displayName = "LabeledSwitch";
export default LabeledSwitch;
